import { createBoundContext } from '@bonusly/design-system';

import { useConfirmDelete } from '../../hooks/use-confirm-delete';
import { useEditEvaluation } from '../../hooks/use-edit-evaluation';
import { FeedbackFilter } from '../../types/filter';

export interface FeedbackContextValue extends ReturnType<typeof useConfirmDelete>, ReturnType<typeof useEditEvaluation> {
	filter: FeedbackFilter;
	scope: 'manager' | 'self';
	userId: string;
}

export const [FeedbackContext, useFeedbackContext] = createBoundContext<FeedbackContextValue>({
	name: 'FeedbackContext',
	providerName: 'FeedbackContext',
	hookName: 'useFeedbackContext',
	// Because of a web of dependencies, we need to provide a default value here so the app/feedback MFE
	// does not get an error when it tries to use the context. It's the `userId` that is the problem, but
	// we don't need it in the app/feedback MFE so we can just provide an empty object for now.
	defaultValue: {} as any,
});
